import { PaginatedTable } from '@app/components/paginated-table';
import { TableProps } from '@app/components/table';
import { IInterviewee } from '../types';
import { IntervieweeRow } from './interviewee-row';

interface Props {
  tableProps: TableProps;
  rows?: IInterviewee[];
  loading: boolean;
  isManager: boolean;
}

const IntervieweeList = ({ tableProps, rows, loading, isManager }: Props) => {
  const TABLE_HEAD = [
    { id: 'id', label: 'Id', align: 'center' },
    { id: 'candidateName', label: 'Name', align: 'center' },
    { id: 'candidateEmail', label: 'Email', align: 'center' },
    { id: 'interviewTime', label: 'interview Time', align: 'center', sortable: false },
    { id: 'interviewer', label: 'interviewer', align: 'center' },
    { id: 'viewResume', label: 'View Resume', align: 'center', sortable: false },
    { id: 'updateStatus', label: 'Update Status', align: 'center', sortable: false },
    { id: 'status', label: 'Status', align: 'center', sortable: false },
    { id: 'reason', label: 'Reason', align: 'center', sortable: false },
    ...(isManager ? [] : [{ id: 'Action', label: 'Action', align: 'center', sortable: false }]),
  ];
  return (
    <PaginatedTable<IInterviewee>
      head={TABLE_HEAD}
      tableProps={tableProps}
      data={rows}
      loading={loading}
      isServerSidePaging={false}
    >
      {(row) => (
        <IntervieweeRow
          row={row}
          isManager={isManager}
          selected={tableProps.selected.includes(row.id)}
          onSelectRow={() => {
            ('');
          }}
        />
      )}
    </PaginatedTable>
  );
};

export { IntervieweeList };
